import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useDeleteData } from "../../../hooks/useDeleteData";
import notify from "../../../components/notify";



export const addOrder = createAsyncThunk(
  "/orderSlice/addOrder",
  async ({ data, rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/orders`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);

export const getOrders = createAsyncThunk(
  "/orderSlice/getOrders",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useGetData(`v1/orders/user/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const getFamilyOrders = createAsyncThunk(
  "/orderSlice/getFamilyOrders",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useGetData(`v1/orders/family/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const editOrder = createAsyncThunk(
  "/orderSlice/editOrder",
  async ({id,data}, { rejectWithValue }) => {
    try {

      const response = await useUpdateData(`v1/orders/family/order/${id}`,data);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const deleteOrder = createAsyncThunk(
  "/orderSlice/deleteOrder",
  async ({id}, { rejectWithValue }) => {
    try {

      const response = await useDeleteData(`v1/order/remove/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);


export const getOrdersCounter = createAsyncThunk(
  "/orderSlice/getOrdersCounter",
  async ({id, type, status}, { rejectWithValue }) => {
    try {

      const response = await useGetData(`v1/orders/getOrderCounter?userId=${id}&type=${type}&orderStatus=${status}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
